import React from 'react';
import HeaderContainer from 'app/containers/Header/HeaderContainer';
import FooterContainer from 'app/containers/Footer/FooterContainer';
import PropTypes from 'prop-types';

import './Administration.css';
import DetailsContainer from '../../containers/Admin/DetailsContainer';

const UserDetailsPage = ({userId}) => {
    return (
        <div className="administration">
            <HeaderContainer adminSite/>
            <DetailsContainer userId={userId}/>
            <FooterContainer/>
        </div>
    );
};

UserDetailsPage.propTypes = {
    userId: PropTypes.number,
};

export {UserDetailsPage};
